import { useCallback, useEffect, useState } from "react";
import useAccommodation from "./useAccommodation.js";
const useAccommodationMobile = (props)=>{
    const { value , onChange  } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [tempValue, setTempValue] = useState(value);
    const { inputProps , panelRooms , config , people , hasError , goToLast , error , onAddRoom , onChangeRooms  } = useAccommodation({
        ...props,
        value: tempValue,
        onChange: setTempValue
    });
    useEffect(()=>{
        if (!isOpen) {
            setTempValue(value);
        }
    }, [
        error,
        isOpen,
        value
    ]);
    const onAddRoomTemp = useCallback((e)=>{
        e.preventDefault();
        if (hasError) return;
        onAddRoom(e);
    }, [
        hasError,
        onAddRoom
    ]);
    const onAccept = useCallback((close)=>()=>{
            if (tempValue && onChange) onChange(tempValue);
            close();
        }, [
        onChange,
        tempValue
    ]);
    return {
        inputProps,
        isOpen,
        onAccept,
        setIsOpen,
        config,
        onChangeRooms,
        people,
        panelRooms,
        hasError,
        error,
        goToLast,
        onAddRoom: onAddRoomTemp
    };
};
export default useAccommodationMobile;

//# sourceMappingURL=useAccommodationMobile.js.map